import React from 'react';

import { useSelector } from 'react-redux';

import AppLoader from '../components/overlays/AppLoader';
import ProcessLoader from '../components/overlays/ProcessLoader';
import ErrorMessages from '../components/error/ErrorMessages';
import ConfirmationDialog from '../components/overlays/ConfirmationDialog';

const OverlayContainer = () => {
  const uiStatus = useSelector((state) => state.ui.uiStatus);

  const renderOverlay = () => {
    switch (uiStatus) {
      case 'loading':
        return <AppLoader />;
      case 'error':
        return <ErrorMessages />;
      case 'process':
        return <ProcessLoader />;
      case 'confirm':
        return <ConfirmationDialog />;
      default:
        return '';
    }
  };

  return (
    <div className="overlay-container">
      {renderOverlay()}
    </div>
  );
};

export default OverlayContainer;
